import { ReactElement } from 'react';

import { reactToWebComponent } from './react-to-web-component';

export const defineWebComponents = (/* istanbul ignore next: default value */ webComponentMap = new Map()) => {
  webComponentMap.forEach((reactElement: ReactElement, webComponentTagName: string) => {
    /* istanbul ignore else */ if (!customElements.get(webComponentTagName)) {
      const webComponentElement = reactToWebComponent(reactElement);
      customElements.define(webComponentTagName, webComponentElement);
      console.info('webComponent defined:', webComponentTagName);
    }
  });
};
